import { RESTRICTED_KRATOM_JURISDICTIONS } from "@shared/shippingRestrictions";
import { MapPinned } from "lucide-react";

type ShippingRestrictionsNoticeProps = {
  variant?: "footer" | "cart" | "checkout";
};

export function ShippingRestrictionsNotice({ variant = "footer" }: ShippingRestrictionsNoticeProps) {
  const compact = variant === "cart";
  return (
    <section className={compact ? "rounded-[1.25rem] border border-[#ffcc7b]/22 bg-[#3d2911]/45 p-4" : "rounded-[1.5rem] border border-[#ffcc7b]/22 bg-[#3d2911]/38 p-5"} aria-labelledby={`shipping-restrictions-${variant}`}>
      <div className="flex items-start gap-3">
        <MapPinned className="mt-0.5 h-5 w-5 shrink-0 text-[#ffd27c]" aria-hidden="true" />
        <div>
          <h2 id={`shipping-restrictions-${variant}`} className="text-sm font-semibold uppercase tracking-[0.16em] text-[#ffe3ad]">Shipping Restrictions</h2>
          <p className="mt-2 text-sm leading-6 text-white/74">Kratown does not ship kratom products to locations where prohibited by law. Orders shipping to restricted jurisdictions will be canceled and refunded.</p>
          <p className="mt-3 text-sm leading-6 text-white/74">We currently do not ship to jurisdictions where kratom is prohibited by law, including:</p>
          <p className="mt-2 text-sm leading-6 text-white/88">{RESTRICTED_KRATOM_JURISDICTIONS.map((jurisdiction) => jurisdiction.name).join(" • ")}</p>
          {!compact ? <p className="mt-3 text-sm leading-6 text-white/62">Laws change frequently. Kratown reserves the right to refuse shipment to any location where our products are prohibited or restricted.</p> : null}
          <a href="/shipping-restrictions" className="mt-4 inline-flex text-sm font-medium text-[#ffe3ad] underline-offset-4 hover:text-white hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffd27c] focus-visible:ring-offset-2 focus-visible:ring-offset-[#3d2911]">
            Read shipping restrictions
          </a>
        </div>
      </div>
    </section>
  );
}
